import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormHelperText,
  Divider,
  Chip,
  Paper,
  Grid,
  Avatar,
  CircularProgress,
  Card,
  CardContent,
  IconButton,
  InputAdornment,
  Collapse,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  LinearProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";
import {
  Receipt,
  AccountBalance,
  Business,
  Person,
  Check,
  Cancel,
  Close,
  Info,
  AttachMoney,
  CalendarToday,
  Description,
  CreditCard,
  CheckCircle,
  CloudUpload,
  Delete,
  Add,
  Build,
  Home,
  LocalDrink,
  LocalMall,
  Storefront,
  InsertDriveFile,
  PictureAsPdf,
  Image,
  Email,
  Phone,
  NotificationsActive,
  Warning,
} from "@material-ui/icons";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import HttpService from "../../services/httpService";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    backgroundColor: "#f5f7fa",
    minHeight: "100vh",
  },
  header: {
    marginBottom: theme.spacing(4),
    padding: theme.spacing(3),
    background: "linear-gradient(135deg, #1A3C6E 0%, #2E75B6 100%)",
    borderRadius: theme.spacing(2),
    color: "#fff",
    boxShadow: "0 8px 32px rgba(26, 60, 110, 0.3)",
  },
  headerTitle: {
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  headerSubtitle: {
    opacity: 0.9,
    marginTop: theme.spacing(0.5),
  },
  notificationBanner: {
    padding: theme.spacing(2, 3),
    borderRadius: theme.spacing(2),
    marginBottom: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    background: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
    border: "1px solid #f59e0b",
  },
  notificationIcon: {
    backgroundColor: "#f59e0b",
    color: "#fff",
    padding: theme.spacing(1),
    borderRadius: "50%",
    marginRight: theme.spacing(1.5),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  notificationText: {
    color: "#92400e",
  },
  notificationChip: {
    backgroundColor: "#f59e0b",
    color: "#fff",
    fontWeight: 600,
  },
  overdueChip: {
    backgroundColor: "#dc2626",
    color: "#fff",
    fontWeight: 600,
  },
  stepper: {
    backgroundColor: "transparent",
    padding: theme.spacing(3, 0),
  },
  stepCard: {
    padding: theme.spacing(3),
    borderRadius: theme.spacing(2),
    backgroundColor: "#fff",
    border: "1px solid #e0e7f0",
  },
  sectionLabel: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
    "& .MuiAvatar-root": {
      backgroundColor: "#EBF3FB",
      color: "#1A3C6E",
      width: 36,
      height: 36,
    },
  },
  navRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: theme.spacing(3),
  },
  backBtn: {
    borderRadius: 10,
    textTransform: "none",
    fontWeight: 600,
    padding: theme.spacing(0.75, 2.5),
    borderColor: "#C8D8EC",
    color: "#1A3C6E",
  },
  nextBtn: {
    borderRadius: 10,
    textTransform: "none",
    fontWeight: 600,
    padding: theme.spacing(0.75, 2.5),
    backgroundColor: "#1A3C6E",
    color: "#fff",
    "&:hover": { backgroundColor: "#2E75B6" },
  },
  fileDropZone: {
    border: "2px dashed #C8D8EC",
    borderRadius: 8,
    padding: theme.spacing(3),
    textAlign: "center",
    cursor: "pointer",
    transition: "all 0.2s",
    "&:hover": {
      borderColor: "#1A3C6E",
      backgroundColor: "#F5F8FC",
    },
    "&.dragging": {
      borderColor: "#1A3C6E",
      backgroundColor: "#EBF3FB",
    },
  },
  uploadedFile: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1),
    backgroundColor: "#F5F8FC",
    borderRadius: 8,
    marginBottom: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#EBF3FB",
    },
  },
  fileIcon: {
    width: 32,
    height: 32,
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#EBF3FB",
    color: "#1A3C6E",
  },
  infoBox: {
    padding: theme.spacing(2),
    backgroundColor: "#FFF8E1",
    borderRadius: 8,
    border: "1px solid #FFE082",
    marginBottom: theme.spacing(2),
  },
  summaryCard: {
    padding: theme.spacing(2),
    backgroundColor: "#f8f9fa",
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  infoRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(0.75, 0),
    borderBottom: "1px solid #e0e7f0",
    "&:last-child": { borderBottom: "none" },
  },
  infoLabel: { color: "#666", fontWeight: 500 },
  infoValue: { fontWeight: 500, color: "#333" },
  uploadProgress: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  fileSize: {
    fontSize: "0.7rem",
    color: "#999",
  },
  raiseNowBtn: {
    backgroundColor: "#92400e",
    color: "#fff",
    textTransform: "none",
    borderRadius: 8,
    "&:hover": {
      backgroundColor: "#78350f",
    },
  },
}));

// ─── Constants ──────────────────────────────────────────────────────────────
// Fixed categories — always present regardless of admin Service Type config.
const FIXED_PAYMENT_TYPES = {
  rent: { label: "Rent", icon: Home, requiresOnboarding: true, allowsManual: false, requiresInvoice: true },
  housekeeping: { label: "Housekeeping", icon: Build, requiresOnboarding: true, allowsManual: false, requiresInvoice: false },
  marketing: { label: "Marketing", icon: Business, requiresOnboarding: false, allowsManual: true, requiresInvoice: false },
  branding: { label: "Branding", icon: Business, requiresOnboarding: false, allowsManual: true, requiresInvoice: false },
  others: { label: "Others", icon: Business, requiresOnboarding: false, allowsManual: true, requiresInvoice: false },
};

// Everything else ("service types") comes from the admin-managed Service Type
// list at runtime (see fetchServiceTypes below), so newly added types work
// without a code change. These are only a bootstrap fallback, used while that
// list is still empty — mirrors the backend's LEGACY_SERVICE_TYPES fallback.
const LEGACY_SP_TYPES = ["stationary", "porter", "ccd", "drinking_water"];
const LEGACY_SP_LABELS = { stationary: "Stationary", porter: "Porter", ccd: "CCD", drinking_water: "Drinking Water" };
const LEGACY_SP_ICONS = { stationary: Storefront, porter: Person, ccd: LocalDrink, drinking_water: LocalDrink };

function buildServiceTypeEntries(names) {
  return Object.fromEntries(names.map((name) => [name, {
    label: LEGACY_SP_LABELS[name] || name,
    icon: LEGACY_SP_ICONS[name] || Storefront,
    requiresOnboarding: false,
    allowsManual: true,
    requiresInvoice: false,
  }]));
}

const PAYMENT_MODES = [
  { value: "erp", label: "ERP (Bank Transfer)", icon: CreditCard },
  { value: "manual", label: "Manual (Already Paid)", icon: AttachMoney },
];

const EXTERNAL_PAYMENT_METHODS = [
  { value: "phonepe", label: "PhonePe" },
  { value: "gpay", label: "Google Pay" },
  { value: "paytm", label: "Paytm" },
  { value: "neft", label: "NEFT" },
  { value: "cash", label: "Cash" },
  { value: "cheque", label: "Cheque" },
  { value: "other", label: "Other" },
];

const ACCOUNT_TYPES = ["savings", "current", "nro", "nre"];

// ─── Service Provider scopes display helper ────────────────────────────────
// providers from /ex/payments/providers/:ecId are shaped with `scopes` (the
// location_mappings entry for the requested EC) instead of a top-level
// service_type, since a provider can offer multiple scopes per location.
const formatProviderScopes = (provider) => {
  const scopes = provider?.scopes || [];
  if (!scopes.length) return "N/A";
  return scopes
    .map((s) => (s.service_type === "others" ? s.service_type_other : s.service_type)?.replace(/_/g, " ").toUpperCase())
    .filter(Boolean)
    .join(", ");
};

// ─── File Icon Helper ──────────────────────────────────────────────────────
const getFileIcon = (fileName) => {
  const extension = fileName?.split('.').pop()?.toLowerCase();
  if (['pdf'].includes(extension)) return <PictureAsPdf style={{ color: '#f44336' }} />;
  if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension)) return <Image style={{ color: '#4caf50' }} />;
  if (['doc', 'docx'].includes(extension)) return <Description style={{ color: '#2196f3' }} />;
  return <InsertDriveFile style={{ color: '#9E9E9E' }} />;
};

// ─── MAIN COMPONENT ──────────────────────────────────────────────────────
const MiscPaymentRaise = function (props) {
  const classes = useStyles();
  const history = useHistory();
  
  // Use ref to prevent infinite loops
  const isFirstRender = useRef(true);
  const ecIdRef = useRef("");
  
  const [loading, setLocalLoading] = useState(false);
  const [allExperienceCenters, setAllExperienceCenters] = useState([]);
  const [activeOwners, setActiveOwners] = useState([]);
  const [activeProviders, setActiveProviders] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [submissionLoading, setSubmissionLoading] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [showManualBankForm, setShowManualBankForm] = useState(false);
  const [selectedRecordBank, setSelectedRecordBank] = useState(null);

  // ─── Notification State ──────────────────────────────────────────────────
  const [notificationData, setNotificationData] = useState(null);
  const [hasNotifications, setHasNotifications] = useState(false);
  const [notificationLoading, setNotificationLoading] = useState(false);
  const [maxRentAmount, setMaxRentAmount] = useState(null);
  const [serviceTypeCap, setServiceTypeCap] = useState(null);

  // ─── Admin-managed Service Types (falls back to the legacy fixed 4 while
  // the admin list is still empty) ──────────────────────────────────────────
  const [spTypes, setSpTypes] = useState(LEGACY_SP_TYPES);
  const [paymentTypes, setPaymentTypes] = useState({
    ...FIXED_PAYMENT_TYPES,
    ...buildServiceTypeEntries(LEGACY_SP_TYPES),
  });

  const fetchServiceTypes = useCallback(async () => {
    try {
      const res = await HttpService.getServiceTypeConfigs();
      const names = (res?.data?.data || []).map((s) => s.name).filter((n) => n !== "housekeeping");
      if (names.length > 0) {
        setSpTypes(names);
        setPaymentTypes({ ...FIXED_PAYMENT_TYPES, ...buildServiceTypeEntries(names) });
      }
    } catch (_) { /* keep legacy fallback */ }
  }, []);

  const [paymentData, setPaymentData] = useState({
    experienceCenterId: "",
    payment_type: "",
    payment_mode: "erp",
    external_payment_method: "",
    linked_owner: "",
    linked_service_provider: "",
    payee_name: "",
    email: "",
    mobile: "",
    amount: "",
    description: "",
    payment_month: "",
    payment_period_label: "",
    remarks: "",
    gst_percentage: "",
    bank: {
      account_number: "",
      account_name: "",
      bank_name: "",
      branch_name: "",
      ifsc_code: "",
      account_type: "savings",
    },
  });

  // Multiple amount + GST rows — collapse into paymentData.amount/gst_percentage
  // (the totals) below, and travel to the backend as payment_lines so each
  // row is kept distinct. TDS is not set here — the approver sets it later.
  const [paymentRows, setPaymentRows] = useState([{ amount: "", gst_percentage: "" }]);

  const [confirmOpen, setConfirmOpen] = useState(false);

  // ─── Fetch Rental Payment Notifications ──────────────────────────────────
  const fetchRentalPaymentNotifications = useCallback(async () => {
    try {
      setNotificationLoading(true);
      const response = await HttpService.getRentalPaymentNotifications();
      
      if (response?.data?.success) {
        const data = response.data.data;
        setNotificationData(data);
        setHasNotifications(data.hasNotifications || false);
      }
    } catch (err) {
      console.error("Failed to fetch rental payment notifications:", err);
    } finally {
      setNotificationLoading(false);
    }
  }, []);

  // ─── Fetch Experience Centres ──────────────────────────────────────────────
  const fetchExperienceCenters = useCallback(async () => {
    try {
      props.setLoading(true);
      const res = await HttpService.getAllExperienceCenter();
      setAllExperienceCenters(res?.data?.data || []);
    } catch (err) {
      props.setSnackInfo("Failed to load Experience Centres", "error");
    } finally {
      props.setLoading(false);
    }
  }, [props]);

  useEffect(() => {
    fetchExperienceCenters();
    fetchRentalPaymentNotifications();
    fetchServiceTypes();
  }, []);

  // ─── Fetch the admin-set (EC + Service Type) cap for live validation ─────
  useEffect(() => {
    const { experienceCenterId, payment_type } = paymentData;
    if (!experienceCenterId || !spTypes.includes(payment_type)) {
      setServiceTypeCap(null);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await HttpService.lookupServiceTypeCap(experienceCenterId, payment_type);
        if (!cancelled) setServiceTypeCap(res?.data?.data?.max_amount ?? null);
      } catch (err) {
        if (!cancelled) setServiceTypeCap(null);
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentData.experienceCenterId, paymentData.payment_type, spTypes]);

  // ─── Fetch active records when EC changes ────────────────────────────────
  const fetchActiveRecords = useCallback(async (ecId) => {
    if (!ecId) return;
    try {
      setLocalLoading(true);
      const [ownersRes, providersRes] = await Promise.all([
        HttpService.getActiveOwnersForPayment(ecId),
        HttpService.getActiveProvidersForPayment(ecId),
      ]);
      setActiveOwners(ownersRes?.data?.data || []);
      setActiveProviders(providersRes?.data?.data || []);
    } catch (err) {
      props.setSnackInfo("Failed to fetch active records", "error");
    } finally {
      setLocalLoading(false);
    }
  }, [props]);

  // Only fetch when experienceCenterId changes
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    
    const ecId = paymentData.experienceCenterId;
    if (ecId && ecId !== ecIdRef.current) {
      ecIdRef.current = ecId;
      fetchActiveRecords(ecId);
    } else if (!ecId) {
      setActiveOwners([]);
      setActiveProviders([]);
      ecIdRef.current = "";
    }
  }, [paymentData.experienceCenterId, fetchActiveRecords]);

  // ─── Payment Justification (GST breakdown across all amount rows) ─────────
  // TDS is intentionally not part of this — it's set later by the approver.
  const getJustification = useCallback(() => {
    const lines = paymentRows.map((row) => {
      const base = parseFloat(row.amount) || 0;
      const gstPct = parseFloat(row.gst_percentage) || 0;
      const gstAmount = Math.round(base * gstPct) / 100;
      return { base, gstPct, gstAmount };
    });
    const base = Math.round(lines.reduce((sum, l) => sum + l.base, 0) * 100) / 100;
    const gstAmount = Math.round(lines.reduce((sum, l) => sum + l.gstAmount, 0) * 100) / 100;
    const netPayable = Math.round((base + gstAmount) * 100) / 100;
    return { lines, base, gstAmount, netPayable };
  }, [paymentRows]);

  // ─── Keep paymentData.amount/gst_percentage in sync as the totals across
  // all rows, so the rest of the form (cap validation, review, submit) keeps
  // working against a single amount as before. ───────────────────────────────
  useEffect(() => {
    const totalAmount = Math.round(
      paymentRows.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0) * 100
    ) / 100;
    setPaymentData((prev) => ({
      ...prev,
      amount: totalAmount > 0 ? String(totalAmount) : "",
    }));
  }, [paymentRows]);

  // ─── Handle amount-row changes ─────────────────────────────────────────────
  const handleRowChange = useCallback((index, field, value) => {
    setPaymentRows((prev) => prev.map((row, i) => (i === index ? { ...row, [field]: value } : row)));
  }, []);

  const addPaymentRow = useCallback(() => {
    setPaymentRows((prev) => [...prev, { amount: "", gst_percentage: "" }]);
  }, []);

  const removePaymentRow = useCallback((index) => {
    setPaymentRows((prev) => (prev.length > 1 ? prev.filter((_, i) => i !== index) : prev));
  }, []);

  // Rent & housekeeping are always a single amount for the month — no
  // multi-row support. Collapse back to one row (keeping the first, dropping
  // the rest) if the type is switched to one of these after extra rows were added.
  const allowsMultipleRows = !['rent', 'housekeeping'].includes(paymentData.payment_type);
  useEffect(() => {
    if (!allowsMultipleRows) {
      setPaymentRows((prev) => (prev.length > 1 ? [prev[0]] : prev));
    }
  }, [allowsMultipleRows]);

  // ─── Handle form changes ──────────────────────────────────────────────────
  const handleChange = useCallback((field, value) => {
    setPaymentData(prev => ({ ...prev, [field]: value }));
  }, []);

  const handleBankChange = useCallback((field, value) => {
    setPaymentData(prev => ({
      ...prev,
      bank: { ...prev.bank, [field]: value }
    }));
  }, []);

  // ─── Handle linked record selection ──────────────────────────────────────
  const handleLinkedOwnerChange = useCallback((ownerId) => {
    handleChange("linked_owner", ownerId);
    // Auto-fill bank details from selected owner
    if (ownerId) {
      const owner = activeOwners.find(o => o._id === ownerId);
      if (owner?.bank) {
        setSelectedRecordBank(owner.bank);
        setPaymentData(prev => ({
          ...prev,
          bank: {
            account_number: owner.bank.account_number || "",
            account_name: owner.bank.account_name || "",
            bank_name: owner.bank.bank_name || "",
            branch_name: owner.bank.branch_name || "",
            ifsc_code: owner.bank.ifsc_code || "",
            account_type: owner.bank.account_type || "savings",
          },
        }));
        setPaymentRows((prev) => {
          const next = [...prev];
          next[0] = { ...next[0], gst_percentage: owner.gst_applicable ? (owner.gst_percentage || "") : next[0].gst_percentage };
          return next;
        });
      }  // Set max rent amount
      if (owner?.rent_amount) {
        setMaxRentAmount(owner.rent_amount);
      } else {
        setMaxRentAmount(null);
      }
      
    }
    setShowManualBankForm(false);
  }, [activeOwners, handleChange]);

  const handleLinkedProviderChange = useCallback((providerId) => {
    handleChange("linked_service_provider", providerId);
    // Auto-fill bank details from selected provider
    if (providerId) {
      const provider = activeProviders.find(p => p._id === providerId);
      if (provider?.bank) {
        setSelectedRecordBank(provider.bank);
        setPaymentData(prev => ({
          ...prev,
          bank: {
            account_number: provider.bank.account_number || "",
            account_name: provider.bank.account_name || "",
            bank_name: provider.bank.bank_name || "",
            branch_name: provider.bank.branch_name || "",
            ifsc_code: provider.bank.ifsc_code || "",
            account_type: provider.bank.account_type || "savings",
          },
        }));
      }
    }
    setShowManualBankForm(false);
  }, [activeProviders, handleChange]);

  // ─── Handle file upload with S3 ──────────────────────────────────────────
  const handleFileUpload = useCallback(async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;

    setUploadingFile(true);
    setUploadProgress(0);

    try {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        
        if (file.size > 10 * 1024 * 1024) {
          props.setSnackInfo(`File "${file.name}" exceeds 10MB limit`, "error");
          continue;
        }

        const formData = new FormData();
        formData.append("file", file);
        
        const response = await HttpService.uploadFile(formData);
        const s3Link = response.data?.s3Link || response.data?.url || response.data;
        
        setUploadedFiles(prev => [...prev, {
          name: file.name,
          size: file.size,
          type: file.type,
          s3Link: s3Link,
          uploadedAt: new Date().toISOString(),
        }]);
        
        setUploadProgress(((i + 1) / files.length) * 100);
      }
      
      props.setSnackInfo(`Successfully uploaded ${files.length} file(s)`, "success");
    } catch (err) {
      props.setSnackInfo("Failed to upload file(s): " + (err?.message || "Unknown error"), "error");
    } finally {
      setUploadingFile(false);
      setUploadProgress(0);
    }
  }, [props]);

  // ─── Drag and Drop Handlers ──────────────────────────────────────────────
  const handleDragEnter = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  }, []);

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    
    const files = Array.from(e.dataTransfer.files || []);
    if (files.length > 0) {
      const syntheticEvent = { target: { files: files } };
      handleFileUpload(syntheticEvent);
    }
  }, [handleFileUpload]);

  // ─── Remove uploaded file ─────────────────────────────────────────────────
  const removeFile = useCallback((index) => {
    setUploadedFiles(prev => prev.filter((_, i) => i !== index));
  }, []);

  // ─── Navigation ────────────────────────────────────────────────────────────
  // ─── Validate the whole single-page form; returns the first error message
  // found (or null if valid). Combines what used to be 3 separate per-step
  // checks now that the wizard is a single page. ──────────────────────────
  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const validateAll = useCallback(() => {
    const paymentType = paymentTypes[paymentData.payment_type];
    const isManual = paymentData.payment_mode === "manual";

    if (!paymentData.experienceCenterId) return "Please select an Experience Centre";
    if (!paymentData.payment_type) return "Please select a payment type";
    if (!paymentData.payment_mode) return "Please select a payment mode";
    if (!paymentData.amount || parseFloat(paymentData.amount) <= 0) return "Please enter a valid amount";
    if (!paymentData.payment_month) return "Please select the payment month";
    if (paymentData.payment_mode === "manual" && !paymentType?.allowsManual) {
      return `Manual payment is not allowed for ${paymentType?.label}. Please use ERP mode.`;
    }

    const rentTypes = ['rent'];
    const housekeepingTypes = ['housekeeping'];
    const otherTypes = ['marketing', 'branding', 'others'];

    // Cannot raise more than the onboarded/admin-set cap for this owner/provider/service.
    const applicableCap = rentTypes.includes(paymentData.payment_type)
      ? maxRentAmount
      : spTypes.includes(paymentData.payment_type)
        ? serviceTypeCap
        : null;
    if (applicableCap && parseFloat(paymentData.amount) > applicableCap) {
      return `Amount cannot exceed the onboarded cap of ₹${applicableCap.toLocaleString("en-IN")}`;
    }

    if (rentTypes.includes(paymentData.payment_type) && !paymentData.linked_owner) {
      return "Please select a rental owner";
    }
    if (housekeepingTypes.includes(paymentData.payment_type) && !paymentData.linked_service_provider) {
      return "Please select a service provider for housekeeping";
    }
    if (isManual && !paymentData.payee_name) {
      return "Please enter payee name for manual payment";
    }
    if (isManual && paymentData.email && !EMAIL_REGEX.test(paymentData.email)) {
      return "Please enter a valid payee email";
    }
    if (spTypes.includes(paymentData.payment_type) && paymentData.payment_mode === "erp") {
      if (!paymentData.linked_service_provider && !showManualBankForm) {
        return "Either select a service provider or enter bank details manually";
      }
      if (showManualBankForm) {
        if (!paymentData.payee_name) return "Please enter payee name";
        if (!paymentData.email) return "Please enter payee email";
        if (!EMAIL_REGEX.test(paymentData.email)) return "Please enter a valid payee email";
        if (!paymentData.mobile) return "Please enter payee number";
        const bank = paymentData.bank;
        if (!bank.account_number || !bank.account_name || !bank.bank_name || !bank.ifsc_code) {
          return "Please fill all required bank fields";
        }
      }
    }
    if (otherTypes.includes(paymentData.payment_type) && !isManual) {
      if (!paymentData.payee_name) return "Please enter payee name";
      if (!paymentData.email) return "Please enter payee email";
      if (!EMAIL_REGEX.test(paymentData.email)) return "Please enter a valid payee email";
      if (!paymentData.mobile) return "Please enter payee number";
      if (paymentData.payment_mode === "erp") {
        const bank = paymentData.bank;
        if (!bank.account_number || !bank.account_name || !bank.bank_name || !bank.ifsc_code) {
          return "Please fill all required bank fields";
        }
      }
    }

    if (uploadedFiles.length === 0) {
      return "Please upload at least one supporting document (invoice/receipt/screenshot)";
    }

    return null;
  }, [paymentData, uploadedFiles, showManualBankForm, maxRentAmount, serviceTypeCap, paymentTypes, spTypes]);

  // ─── Validate, then open the confirmation dialog before submitting ──────
  const handleReviewAndSubmit = useCallback(() => {
    const error = validateAll();
    if (error) {
      props.setSnackInfo(error, "error");
      return;
    }
    setConfirmOpen(true);
  }, [validateAll, props]);

  // ─── Submit Payment ──────────────────────────────────────────────────────
  const handleSubmit = useCallback(async () => {
    try {

      if (paymentData.payment_type === 'rent' && paymentData.linked_owner) {
        const owner = activeOwners.find(o => o._id === paymentData.linked_owner);
        if (owner?.rent_amount) {
          const requestedAmount = parseFloat(paymentData.amount);
          const maxAllowed = parseFloat(owner.rent_amount);

          if (requestedAmount > maxAllowed) {
            props.setSnackInfo(
              `Payment amount (₹${requestedAmount}) exceeds the onboarding amount (₹${maxAllowed}). Please enter an amount up to ₹${maxAllowed}.`,
              "error"
            );
            return;
          }
        }
      }
      setSubmissionLoading(true);
      
      const documents = uploadedFiles.map(file => ({
        doc_type: "invoice",
        file_path: file.s3Link || file.name,
        original_name: file.name,
        mime_type: file.type || "application/octet-stream",
        file_size_kb: Math.round(file.size / 1024),
        uploaded_at: file.uploadedAt || new Date().toISOString(),
      }));

      let bankDetails = undefined;
      if (paymentData.payment_mode === "erp") {
        const rentTypes = ['rent'];
        const housekeepingTypes = ['housekeeping'];
        const isRentOrHousekeeping = rentTypes.includes(paymentData.payment_type) || housekeepingTypes.includes(paymentData.payment_type);
        
        if (!isRentOrHousekeeping || showManualBankForm) {
          bankDetails = paymentData.bank;
        } else if (isRentOrHousekeeping && paymentData.linked_owner) {
          bankDetails = undefined;
        } else if (isRentOrHousekeeping && paymentData.linked_service_provider) {
          bankDetails = undefined;
        }
      }

      const payment_lines = paymentRows
        .map((row) => ({
          amount: parseFloat(row.amount) || 0,
          gst_percentage: parseFloat(row.gst_percentage) || 0,
        }))
        .filter((row) => row.amount > 0);

      const payload = {
        ...paymentData,
        amount: parseFloat(paymentData.amount),
        payment_lines,
        documents: documents,
        bank: bankDetails,
      };

      const res = await HttpService.raisePayment(payload);

      if (res?.data?.success) {
        setConfirmOpen(false);
        setSubmitted(true);
        props.setSnackInfo("Payment request raised successfully!", "success");
      }
    } catch (err) {
      setConfirmOpen(false);
      props.setSnackInfo(
        err?.response?.data?.message || "Failed to raise payment",
        "error"
      );
    } finally {
      setSubmissionLoading(false);
    }
  }, [paymentData, paymentRows, uploadedFiles, showManualBankForm, props]);

  // ─── Render Notification Banner ──────────────────────────────────────────
  // const renderNotificationBanner = () => {
  //   if (!hasNotifications || !notificationData || notificationData.owners?.length === 0) {
  //     return null;
  //   }

  //   const { owners, summary } = notificationData;
  //   const overdueCount = owners.filter(o => o.isOverdue).length;
  //   const pendingCount = owners.length - overdueCount;

  //   return (
  //     <Paper className={classes.notificationBanner}>
  //       <Box display="flex" alignItems="center" flexWrap="wrap" gap={1}>
  //         <div className={classes.notificationIcon}>
  //           <NotificationsActive style={{ fontSize: 20 }} />
  //         </div>
  //         <Box>
  //           <Typography variant="body1" className={classes.notificationText} style={{ fontWeight: 600 }}>
  //             ⚠️ Rent Payment Reminder
  //           </Typography>
  //           <Typography variant="body2" className={classes.notificationText}>
  //             {summary.pending} rental owner(s) need to raise payment for {summary.paymentMonth}
  //             {overdueCount > 0 && ` (${overdueCount} overdue)`}
  //           </Typography>
  //           <Box display="flex" gap={1} mt={0.5} flexWrap="wrap">
  //             <Chip
  //               size="small"
  //               label={`${pendingCount} pending`}
  //               className={classes.notificationChip}
  //             />
  //             {overdueCount > 0 && (
  //               <Chip
  //                 size="small"
  //                 label={`${overdueCount} overdue`}
  //                 className={classes.overdueChip}
  //               />
  //             )}
  //             <Chip
  //               size="small"
  //               label={`Due for ${summary.paymentMonth}`}
  //               variant="outlined"
  //               style={{ borderColor: "#f59e0b", color: "#78350f" }}
  //             />
  //           </Box>
  //         </Box>
  //       </Box>
  //       <Button
  //         variant="contained"
  //         className={classes.raiseNowBtn}
  //         onClick={() => {
  //           // Auto-select rent payment type and focus on rent
  //           handleChange("payment_type", "rent");
  //           // Scroll to payment type field
  //           const element = document.getElementById("payment-type-select");
  //           if (element) element.scrollIntoView({ behavior: "smooth" });
  //         }}
  //       >
  //         Raise Now
  //       </Button>
  //     </Paper>
  //   );
  // };
  // ─── Render Notification Banner ──────────────────────────────────────────
const renderNotificationBanner = () => {
  if (!hasNotifications || !notificationData || notificationData.owners?.length === 0) {
    return null;
  }

  const { owners, summary } = notificationData;
  const overdueCount = owners.filter(o => o.isOverdue).length;
  const pendingCount = owners.length - overdueCount;

  return (
    <Paper className={classes.notificationBanner}>
      <Box display="flex" alignItems="flex-start" flexWrap="wrap" gap={1} flex={1}>
        <div className={classes.notificationIcon}>
          <NotificationsActive style={{ fontSize: 20 }} />
        </div>
        <Box flex={1}>
          <Typography variant="body1" className={classes.notificationText} style={{ fontWeight: 600 }}>
            ⚠️ Rent Payment Reminder
          </Typography>
          <Typography variant="body2" className={classes.notificationText}>
            {summary.pending} rental owner(s) need to raise payment for {summary.paymentMonthDisplay}
            {overdueCount > 0 && ` (${overdueCount} overdue)`}
          </Typography>
          
          {/* ─── Owner List with Experience Center ────────────────────── */}
          <Box mt={1} display="flex" flexWrap="wrap">
            {owners.map((owner, index) => (
              <Chip
                key={index}
                size="small"
                label={`${owner.ownerName} (${owner.experienceCenter})`}
                style={{
                  backgroundColor: owner.isOverdue ? "#fee2e2" : "#fef3c7",
                  color: owner.isOverdue ? "#dc2626" : "#92400e",
                  marginRight: 6,
                  marginBottom: 4,
                  fontWeight: 500,
                  fontSize: "0.7rem",
                }}
                icon={owner.isOverdue ? <Warning style={{ fontSize: 14 }} /> : undefined}
              />
            ))}
          </Box>

          <Box display="flex" gap={1} mt={1} flexWrap="wrap">
            <Chip
              size="small"
              label={`${pendingCount} pending`}
              className={classes.notificationChip}
            />
            {overdueCount > 0 && (
              <Chip
                size="small"
                label={`${overdueCount} overdue`}
                className={classes.overdueChip}
              />
            )}
            <Chip
              size="small"
              label={`Due for ${summary.paymentMonthDisplay}`}
              variant="outlined"
              style={{ borderColor: "#f59e0b", color: "#78350f" }}
            />
          </Box>
        </Box>
      </Box>
      <Button
        variant="contained"
        className={classes.raiseNowBtn}
        onClick={() => {
          handleChange("payment_type", "rent");
          const element = document.getElementById("payment-type-select");
          if (element) element.scrollIntoView({ behavior: "smooth" });
        }}
      >
        Raise Now
      </Button>
    </Paper>
  );
};

  // ─── Render Step 0: Payment Details ──────────────────────────────────────
  const renderStep0 = () => {
    const selectedPaymentType = paymentTypes[paymentData.payment_type];

    return (
      <div>
        <div className={classes.sectionLabel}>
          <Avatar>
            <Receipt />
          </Avatar>
          <Typography variant="h6" style={{ fontWeight: 600 }}>
            Payment Details
          </Typography>
        </div>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined" size="small">
              <InputLabel>Experience Centre *</InputLabel>
              <Select
                value={paymentData.experienceCenterId}
                label="Experience Centre *"
                onChange={(e) => handleChange("experienceCenterId", e.target.value)}
              >
                {allExperienceCenters.map((ec) => (
                  <MenuItem key={ec._id} value={ec._id}>{ec.name} - {ec.location}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth variant="outlined" size="small" id="payment-type-select">
              <InputLabel>Payment Type *</InputLabel>
              <Select
                value={paymentData.payment_type}
                label="Payment Type *"
                onChange={(e) => {
                  const val = e.target.value;
                  handleChange("payment_type", val);
                  handleChange("linked_owner", "");
                  handleChange("linked_service_provider", "");
                  handleChange("payee_name", "");
                  const typeInfo = paymentTypes[val];
                  if (typeInfo && !typeInfo.allowsManual) {
                    handleChange("payment_mode", "erp");
                  }
                }}
              >
                {Object.entries(paymentTypes).map(([key, { label, icon: Icon, requiresInvoice, allowsManual }]) => (
                  <MenuItem key={key} value={key}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Icon style={{ fontSize: 18 }} />
                      {label}
                      {requiresInvoice && (
                        <Chip 
                          size="small" 
                          label="Invoice Required" 
                          style={{ marginLeft: 8, fontSize: 10, backgroundColor: "#FFF3E0", color: "#E65100" }} 
                        />
                      )}
                      {!allowsManual && (
                        <Chip size="small" label="ERP Only" style={{ marginLeft: 4, fontSize: 10 }} />
                      )}
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth variant="outlined" size="small">
              <InputLabel>Payment Mode *</InputLabel>
              <Select
                value={paymentData.payment_mode}
                label="Payment Mode *"
                onChange={(e) => {
                  const val = e.target.value;
                  handleChange("payment_mode", val);
                  if (val === "manual" && selectedPaymentType && !selectedPaymentType.allowsManual) {
                    props.setSnackInfo(`Manual payment is not allowed for ${selectedPaymentType.label}`, "warning");
                  }
                  if (val === "manual") {
                    setShowManualBankForm(false);
                  }
                }}
              >
                {PAYMENT_MODES.map((pm) => {
                  const disabled = pm.value === "manual" && selectedPaymentType && !selectedPaymentType.allowsManual;
                  return (
                    <MenuItem key={pm.value} value={pm.value} disabled={disabled}>
                      <Box display="flex" alignItems="center" gap={1}>
                        <pm.icon style={{ fontSize: 18 }} />
                        {pm.label}
                        {disabled && (
                          <Chip size="small" label="Not Allowed" style={{ marginLeft: 8, fontSize: 10, backgroundColor: "#ffebee" }} />
                        )}
                      </Box>
                    </MenuItem>
                  );
                })}
              </Select>
              {selectedPaymentType && !selectedPaymentType.allowsManual && (
                <FormHelperText style={{ color: "#f44336" }}>
                  Manual payment is not allowed for {selectedPaymentType.label}. Please use ERP mode.
                </FormHelperText>
              )}
            </FormControl>
          </Grid>

          {paymentData.payment_mode === "manual" && (
            <Grid item xs={12}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel>External Payment Method</InputLabel>
                <Select
                  value={paymentData.external_payment_method}
                  label="External Payment Method"
                  onChange={(e) => handleChange("external_payment_method", e.target.value)}
                >
                  {EXTERNAL_PAYMENT_METHODS.map((pm) => (
                    <MenuItem key={pm.value} value={pm.value}>{pm.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}

          <Grid item xs={12}>
            <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 8 }}>
              Amount {paymentRows.length > 1 ? `(${paymentRows.length} rows)` : ""}
            </Typography>
            {paymentRows.map((row, index) => (
              <Grid container spacing={2} key={index} alignItems="flex-start" style={{ marginBottom: 8 }}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    label={paymentRows.length > 1 ? `Amount ${index + 1} *` : "Amount *"}
                    type="number"
                    inputProps={{ min: 0, step: 0.01 }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">₹</InputAdornment>
                      ),
                    }}
                    value={row.amount}
                    onChange={(e) => handleRowChange(index, "amount", e.target.value)}
                  />
                </Grid>
                <Grid item xs={allowsMultipleRows ? 8 : 12} sm={allowsMultipleRows ? 4 : 6}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    label="GST %"
                    type="number"
                    inputProps={{ min: 0, max: 100, step: 0.5 }}
                    value={row.gst_percentage}
                    onChange={(e) => handleRowChange(index, "gst_percentage", e.target.value)}
                  />
                </Grid>
                {allowsMultipleRows && (
                  <Grid item xs={4} sm={2} style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 40 }}>
                    <IconButton
                      size="small"
                      onClick={() => removePaymentRow(index)}
                      disabled={paymentRows.length === 1}
                    >
                      <Delete fontSize="small" />
                    </IconButton>
                  </Grid>
                )}
              </Grid>
            ))}
            <Typography variant="caption" color="textSecondary" display="block" style={{ marginBottom: 8 }}>
              Base amount before GST — the approver applies TDS (if any) later
            </Typography>
            {allowsMultipleRows && (
              <Button
                size="small"
                color="primary"
                startIcon={<Add />}
                onClick={addPaymentRow}
                style={{ marginBottom: 8 }}
              >
                Add Another Line Item
              </Button>
            )}

            {(() => {
              const applicableCap = paymentData.payment_type === 'rent'
                ? maxRentAmount
                : spTypes.includes(paymentData.payment_type)
                  ? serviceTypeCap
                  : null;
              const totalAmount = parseFloat(paymentData.amount) || 0;
              const exceedsCap = applicableCap && totalAmount > applicableCap;
              if (exceedsCap) {
                return (
                  <Alert severity="error" style={{ marginBottom: 8 }}>
                    Total amount (₹{totalAmount.toLocaleString("en-IN")}) cannot exceed the onboarded cap of ₹{applicableCap.toLocaleString("en-IN")}
                  </Alert>
                );
              }
              if (applicableCap) {
                return (
                  <Typography variant="caption" color="textSecondary" display="block" style={{ marginBottom: 8 }}>
                    Onboarded cap for this selection: ₹{applicableCap.toLocaleString("en-IN")}
                  </Typography>
                );
              }
              return null;
            })()}

            {(() => {
              const j = getJustification();
              if (j.base <= 0) return null;
              return (
                <Alert severity="info">
                  Payment Justification: ₹{j.base.toLocaleString("en-IN")}
                  {j.gstAmount ? ` + GST (₹${j.gstAmount.toLocaleString("en-IN")})` : ""}
                  {" "}= <strong>₹{j.netPayable.toLocaleString("en-IN")} net payable</strong>
                  {" "}(TDS, if any, will be applied by the approver)
                </Alert>
              );
            })()}
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              required
              label="Payment Month"
              type="month"
              value={paymentData.payment_month}
              onChange={(e) => handleChange("payment_month", e.target.value)}
              error={!paymentData.payment_month}
              helperText={!paymentData.payment_month ? "Select the month this payment is being raised for" : ""}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <CalendarToday style={{ fontSize: 18, color: "#9E9E9E" }} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              label="Description"
              multiline
              rows={2}
              value={paymentData.description}
              onChange={(e) => handleChange("description", e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Description style={{ fontSize: 18, color: "#9E9E9E" }} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              label="Remarks"
              multiline
              rows={1}
              value={paymentData.remarks}
              onChange={(e) => handleChange("remarks", e.target.value)}
            />
          </Grid>
        </Grid>
      </div>
    );
  };

  // ─── Render Step 1: Link/Manual Entry ──────────────────────────────────
  const renderStep1 = () => {
    const rentTypes = ['rent'];
    const housekeepingTypes = ['housekeeping'];
    const otherTypes = ['marketing', 'branding', 'others'];
    const isRent = rentTypes.includes(paymentData.payment_type);
    const isHousekeeping = housekeepingTypes.includes(paymentData.payment_type);
    const isSP = spTypes.includes(paymentData.payment_type);
    const isOther = otherTypes.includes(paymentData.payment_type);
    const isMandatoryOnboarding = isRent || isHousekeeping;
    const isManual = paymentData.payment_mode === "manual";

    return (
      <div>
        <div className={classes.sectionLabel}>
          <Avatar>
            <Person />
          </Avatar>
          <Typography variant="h6" style={{ fontWeight: 600 }}>
            {isMandatoryOnboarding ? "Linked Record" : "Link or Manual Entry"}
          </Typography>
        </div>

        {isManual && (
          <Alert severity="info" style={{ marginBottom: 16 }}>
            <strong>Manual Payment:</strong> Please enter the payee details and upload the invoice/screenshot in the next step.
            No bank details needed.
          </Alert>
        )}

        {isMandatoryOnboarding && (
          <Alert severity="info" style={{ marginBottom: 16 }}>
            {isRent && "Select the rental owner for this rent payment (mandatory)"}
            {isHousekeeping && "Select the service provider for housekeeping (mandatory)"}
            <br />
            <strong>Note:</strong> Bank details will be auto-filled from the selected record.
          </Alert>
        )}

        {isRent && (
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel>Select Rental Owner *</InputLabel>
            <Select
              value={paymentData.linked_owner}
              label="Select Rental Owner *"
              onChange={(e) => handleLinkedOwnerChange(e.target.value)}
              disabled={isManual}
            >
              {activeOwners.map((owner) => (
                <MenuItem key={owner._id} value={owner._id}>
                  <Box>
                    <Typography variant="body2">{owner.owner_name}</Typography>
                    <Typography variant="caption" color="textSecondary">
                      PAN: {owner.pan_number} · Bank: {owner.bank?.bank_name}
                    </Typography>
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {isHousekeeping && (
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel>Select Service Provider *</InputLabel>
            <Select
              value={paymentData.linked_service_provider}
              label="Select Service Provider *"
              onChange={(e) => handleLinkedProviderChange(e.target.value)}
              disabled={isManual}
            >
              {activeProviders.map((provider) => (
                <MenuItem key={provider._id} value={provider._id}>
                  <Box>
                    <Typography variant="body2">{provider.name}</Typography>
                    <Typography variant="caption" color="textSecondary">
                      {formatProviderScopes(provider)} · Mobile: {provider.mobile}
                    </Typography>
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {isSP && !isManual && (
          <>
            <Alert severity="info" style={{ marginBottom: 16 }}>
              You can either select an existing service provider or enter bank details manually.
            </Alert>

            <FormControl fullWidth variant="outlined" size="small" style={{ marginBottom: 16 }}>
              <InputLabel>Select Service Provider (Optional)</InputLabel>
              <Select
                value={paymentData.linked_service_provider}
                label="Select Service Provider (Optional)"
                onChange={(e) => {
                  const val = e.target.value;
                  handleChange("linked_service_provider", val);
                  if (val) {
                    const provider = activeProviders.find(p => p._id === val);
                    if (provider?.bank) {
                      setPaymentData(prev => ({
                        ...prev,
                        bank: {
                          account_number: provider.bank.account_number || "",
                          account_name: provider.bank.account_name || "",
                          bank_name: provider.bank.bank_name || "",
                          branch_name: provider.bank.branch_name || "",
                          ifsc_code: provider.bank.ifsc_code || "",
                          account_type: provider.bank.account_type || "savings",
                        }
                      }));
                    }
                    setShowManualBankForm(false);
                  }
                }}
              >
                <MenuItem value="">None - Enter manually</MenuItem>
                {activeProviders.map((provider) => (
                  <MenuItem key={provider._id} value={provider._id}>
                    <Box>
                      <Typography variant="body2">{provider.name}</Typography>
                      <Typography variant="caption" color="textSecondary">
                        {formatProviderScopes(provider)} · Mobile: {provider.mobile}
                      </Typography>
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {!paymentData.linked_service_provider && (
              <Button
                variant="outlined"
                size="small"
                startIcon={<AccountBalance />}
                onClick={() => setShowManualBankForm(!showManualBankForm)}
                style={{ marginBottom: 16 }}
              >
                {showManualBankForm ? "Hide Bank Details" : "Enter Bank Details Manually"}
              </Button>
            )}
          </>
        )}

        {isOther && !isManual && (
          <Alert severity="info" style={{ marginBottom: 16 }}>
            Please enter the payee and bank details below.
          </Alert>
        )}

        {isManual && (
          <>
            <div style={{ marginTop: 16 }}>
              <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 16 }}>
                Payee Details
              </Typography>
              <Alert severity="info" style={{ marginBottom: 16 }}>
                Please enter the payee details for this manual payment.
              </Alert>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    label="Payee Name *"
                    value={paymentData.payee_name}
                    onChange={(e) => handleChange("payee_name", e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Person style={{ fontSize: 18, color: "#9E9E9E" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    label="Email"
                    type="email"
                    value={paymentData.email || ""}
                    onChange={(e) => handleChange("email", e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Email style={{ fontSize: 18, color: "#9E9E9E" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    label="Mobile Number"
                    value={paymentData.mobile || ""}
                    onChange={(e) => handleChange("mobile", e.target.value.replace(/\D/g, "").slice(0, 10))}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Phone style={{ fontSize: 18, color: "#9E9E9E" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </>
        )}

        {(showManualBankForm || isOther) && !isManual && (
          <div style={{ marginTop: 16 }}>
            <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 16 }}>
              Payee & Bank Details
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Payee Name *"
                  value={paymentData?.payee_name}
                  onChange={(e) => handleChange("payee_name", e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Person style={{ fontSize: 18, color: "#9E9E9E" }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Payee Email *"
                  type="email"
                  value={paymentData.email || ""}
                  onChange={(e) => handleChange("email", e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Email style={{ fontSize: 18, color: "#9E9E9E" }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Payee Number *"
                  value={paymentData.mobile || ""}
                  onChange={(e) => handleChange("mobile", e.target.value.replace(/\D/g, "").slice(0, 10))}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Phone style={{ fontSize: 18, color: "#9E9E9E" }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Account Holder Name *"
                  value={paymentData.bank.account_name}
                  onChange={(e) => handleBankChange("account_name", e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Account Number *"
                  value={paymentData.bank.account_number}
                  onChange={(e) => handleBankChange("account_number", e.target.value.replace(/\D/g, ""))}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Bank Name *"
                  value={paymentData.bank.bank_name}
                  onChange={(e) => handleBankChange("bank_name", e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Branch Name *"
                  value={paymentData.bank.branch_name}
                  onChange={(e) => handleBankChange("branch_name", e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="IFSC Code *"
                  placeholder="SBIN0001234"
                  value={paymentData.bank.ifsc_code}
                  onChange={(e) => handleBankChange("ifsc_code", e.target.value.toUpperCase())}
                  inputProps={{ maxLength: 11 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel>Account Type</InputLabel>
                  <Select
                    value={paymentData.bank.account_type}
                    label="Account Type"
                    onChange={(e) => handleBankChange("account_type", e.target.value)}
                  >
                    {ACCOUNT_TYPES.map((t) => (
                      <MenuItem key={t} value={t}>{t.toUpperCase()}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </div>
        )}

        {isSP && !isManual && !paymentData.linked_service_provider && !showManualBankForm && (
          <Alert severity="warning" style={{ marginTop: 16 }}>
            Please either select a service provider or click "Enter Bank Details Manually" to proceed.
          </Alert>
        )}
      </div>
    );
  };

  // ─── Render Step 2: Upload Documents ──────────────────────────────────
  const renderStep2 = () => {
    const isManual = paymentData.payment_mode === "manual";
    const paymentType = paymentTypes[paymentData.payment_type];
    const requiresInvoice = paymentType?.requiresInvoice;

    return (
      <div>
        <div className={classes.sectionLabel}>
          <Avatar>
            <CloudUpload />
          </Avatar>
          <Typography variant="h6" style={{ fontWeight: 600 }}>
            Upload Documents
          </Typography>
        </div>

        {requiresInvoice && (
          <div className={classes.infoBox}>
            <Info style={{ fontSize: 18, color: "#F57C00", marginRight: 8 }} />
            <Typography variant="body2">
              <strong>Invoice Required:</strong> Please upload the invoice for this payment.
              This is mandatory for {paymentType?.label}.
            </Typography>
          </div>
        )}

        {isManual && (
          <div className={classes.infoBox}>
            <Info style={{ fontSize: 18, color: "#F57C00", marginRight: 8 }} />
            <Typography variant="body2">
              <strong>Manual Payment:</strong> Please upload the invoice or payment confirmation screenshot as proof.
              This is mandatory for manual payments.
            </Typography>
          </div>
        )}

        {!requiresInvoice && !isManual && (
          <div className={classes.infoBox}>
            <Info style={{ fontSize: 18, color: "#F57C00", marginRight: 8 }} />
            <Typography variant="body2">
              <strong>Document Required:</strong> Please upload a supporting document (invoice/receipt/screenshot).
              This is mandatory for all payments.
            </Typography>
          </div>
        )}

        <div
          className={`${classes.fileDropZone} ${isDragging ? 'dragging' : ''}`}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          onClick={() => document.getElementById('fileUpload').click()}
        >
          <input
            id="fileUpload"
            type="file"
            multiple
            accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
            style={{ display: "none" }}
            onChange={handleFileUpload}
          />
          <CloudUpload style={{ fontSize: 40, color: "#9E9E9E" }} />
          <Typography variant="body2" style={{ marginTop: 8 }}>
            Click to upload or drag & drop files
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Supported formats: PDF, JPG, PNG, DOC (Max 10MB each)
          </Typography>
          <Typography variant="caption" style={{ color: "#f44336", display: "block", marginTop: 4 }}>
            * {requiresInvoice ? "Invoice" : "Document"} is required
          </Typography>
        </div>

        {uploadingFile && (
          <div className={classes.uploadProgress}>
            <LinearProgress variant="determinate" value={uploadProgress} />
            <Typography variant="caption" color="textSecondary" style={{ marginTop: 4 }}>
              Uploading... {Math.round(uploadProgress)}%
            </Typography>
          </div>
        )}

        {uploadedFiles.length > 0 && (
          <div style={{ marginTop: 16 }}>
            <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 8 }}>
              Uploaded Files ({uploadedFiles.length})
            </Typography>
            {uploadedFiles.map((file, index) => (
              <div key={index} className={classes.uploadedFile}>
                <div className={classes.fileIcon}>
                  {getFileIcon(file.name)}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <Typography variant="body2" noWrap>
                    {file.name}
                  </Typography>
                  <Typography variant="caption" className={classes.fileSize}>
                    {(file.size / 1024).toFixed(1)} KB
                    {file.s3Link && (
                      <span style={{ color: "#4caf50", marginLeft: 8 }}>
                        ✓ Uploaded to cloud
                      </span>
                    )}
                  </Typography>
                </div>
                <IconButton size="small" onClick={() => removeFile(index)}>
                  <Delete style={{ fontSize: 18, color: "#f44336" }} />
                </IconButton>
              </div>
            ))}
          </div>
        )}

        {uploadedFiles.length === 0 && !uploadingFile && (
          <Alert severity="error" style={{ marginTop: 16 }}>
            {requiresInvoice
              ? "At least one invoice is required for this payment type."
              : isManual
                ? "At least one invoice or payment screenshot is required for manual payments."
                : "At least one supporting document is required for this payment."}
          </Alert>
        )}
      </div>
    );
  };

  // ─── Render Step 3: Review & Submit ──────────────────────────────────
  const renderStep3 = () => {
    const selectedEC = allExperienceCenters.find(
      ec => ec._id === paymentData.experienceCenterId
    );
    const selectedOwner = activeOwners.find(
      o => o._id === paymentData.linked_owner
    );
    const selectedProvider = activeProviders.find(
      p => p._id === paymentData.linked_service_provider
    );
    const paymentTypeInfo = paymentTypes[paymentData.payment_type];
    const isManual = paymentData.payment_mode === "manual";

    return (
      <div>
        <div className={classes.sectionLabel}>
          <Avatar>
            <Check />
          </Avatar>
          <Typography variant="h6" style={{ fontWeight: 600 }}>
            Review & Submit
          </Typography>
        </div>

        <Alert severity="info" style={{ marginBottom: 16 }}>
          Please review all payment details before submitting.
        </Alert>

        <Card className={classes.summaryCard} variant="outlined">
          <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 12 }}>
            Payment Details
          </Typography>
          <div className={classes.infoRow}>
            <span className={classes.infoLabel}>Experience Centre</span>
            <span className={classes.infoValue}>{selectedEC?.name || "—"}</span>
          </div>
          <div className={classes.infoRow}>
            <span className={classes.infoLabel}>Payment Type</span>
            <span className={classes.infoValue}>{paymentTypeInfo?.label || "—"}</span>
          </div>
          <div className={classes.infoRow}>
            <span className={classes.infoLabel}>Payment Mode</span>
            <span className={classes.infoValue}>{paymentData.payment_mode?.toUpperCase()}</span>
          </div>
          {paymentRows.length > 1 ? (
            paymentRows.map((row, index) => (
              <div className={classes.infoRow} key={index}>
                <span className={classes.infoLabel}>Amount {index + 1}</span>
                <span className={classes.infoValue}>
                  ₹{row.amount || 0}{row.gst_percentage ? ` + ${row.gst_percentage}% GST` : ""}
                </span>
              </div>
            ))
          ) : null}
          <div className={classes.infoRow}>
            <span className={classes.infoLabel}>{paymentRows.length > 1 ? "Total Base Amount" : "Amount"}</span>
            <span className={classes.infoValue}>₹{paymentData.amount}</span>
          </div>
          {(() => {
            const j = getJustification();
            if (!j.gstAmount) return null;
            return (
              <>
                <div className={classes.infoRow}>
                  <span className={classes.infoLabel}>GST</span>
                  <span className={classes.infoValue}>+₹{j.gstAmount.toLocaleString("en-IN")}</span>
                </div>
                <div className={classes.infoRow}>
                  <span className={classes.infoLabel}>Net Payable</span>
                  <span className={classes.infoValue}>₹{j.netPayable.toLocaleString("en-IN")}</span>
                </div>
              </>
            );
          })()}
          {paymentData.payment_month && (
            <div className={classes.infoRow}>
              <span className={classes.infoLabel}>Payment Month</span>
              <span className={classes.infoValue}>
                {new Date(paymentData.payment_month + "-01").toLocaleString('default', { 
                  month: 'long', 
                  year: 'numeric' 
                })}
              </span>
            </div>
          )}
          {paymentData.description && (
            <div className={classes.infoRow}>
              <span className={classes.infoLabel}>Description</span>
              <span className={classes.infoValue}>{paymentData.description}</span>
            </div>
          )}
        </Card>


        {(selectedOwner || selectedProvider || paymentData.payee_name) && (
          <Card className={classes.summaryCard} variant="outlined" style={{ marginTop: 16 }}>
            <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 12 }}>
              Linked Record
            </Typography>
            {selectedOwner && (
              <>
                <div className={classes.infoRow}>
                  <span className={classes.infoLabel}>Owner Name</span>
                  <span className={classes.infoValue}>{selectedOwner.owner_name}</span>
                </div>
                <div className={classes.infoRow}>
                  <span className={classes.infoLabel}>PAN</span>
                  <span className={classes.infoValue}>{selectedOwner.pan_number}</span>
                </div>
                {!isManual && selectedOwner.bank && (
                  <div className={classes.infoRow}>
                    <span className={classes.infoLabel}>Bank</span>
                    <span className={classes.infoValue}>
                      {selectedOwner.bank.bank_name} - {selectedOwner.bank.account_number}
                    </span>
                  </div>
                )}
              </>
            )}
            {selectedOwner && selectedOwner.gst_percentage && (
              <div className={classes.infoRow}>
                <span className={classes.infoLabel}>GST Percentage</span>
                <span className={classes.infoValue}>{selectedOwner.gst_percentage}%</span>
              </div>
            )}
            {selectedProvider && (
              <>
                <div className={classes.infoRow}>
                  <span className={classes.infoLabel}>Provider Name</span>
                  <span className={classes.infoValue}>{selectedProvider.name}</span>
                </div>
                <div className={classes.infoRow}>
                  <span className={classes.infoLabel}>Service Type</span>
                  <span className={classes.infoValue}>
                    {formatProviderScopes(selectedProvider)}
                  </span>
                </div>
                {!isManual && selectedProvider.bank && (
                  <div className={classes.infoRow}>
                    <span className={classes.infoLabel}>Bank Name / Acc No</span>
                    <span className={classes.infoValue}>
                      {selectedProvider.bank.bank_name} / {selectedProvider.bank.account_number}
                    </span>
                  </div>
                )}
              </>
            )}
            {paymentData.payee_name && (
              <div className={classes.infoRow}>
                <span className={classes.infoLabel}>Payee Name</span>
                <span className={classes.infoValue}>{paymentData.payee_name}</span>
              </div>
            )}
            {paymentData.email && (
              <div className={classes.infoRow}>
                <span className={classes.infoLabel}>Payee Email</span>
                <span className={classes.infoValue}>{paymentData.email}</span>
              </div>
            )}
            {paymentData.mobile && (
              <div className={classes.infoRow}>
                <span className={classes.infoLabel}>Payee Mobile</span>
                <span className={classes.infoValue}>{paymentData.mobile}</span>
              </div>
            )}
          </Card>
        )}

        {!isManual && (paymentData.bank.account_number || paymentData.bank.bank_name) && (
          <Card className={classes.summaryCard} variant="outlined" style={{ marginTop: 16 }}>
            <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 12 }}>
              Bank Details
            </Typography>
            <div className={classes.infoRow}>
              <span className={classes.infoLabel}>Account Number</span>
              <span className={classes.infoValue}>{paymentData.bank.account_number}</span>
            </div>
            <div className={classes.infoRow}>
              <span className={classes.infoLabel}>Account Holder Name</span>
              <span className={classes.infoValue}>{paymentData.bank.account_name}</span>
            </div>
            <div className={classes.infoRow}>
              <span className={classes.infoLabel}>Bank / IFSC</span>
              <span className={classes.infoValue}>
                {paymentData.bank.bank_name} / {paymentData.bank.ifsc_code}
              </span>
            </div>
          </Card>
        )}

        {uploadedFiles.length > 0 && (
          <Card className={classes.summaryCard} variant="outlined" style={{ marginTop: 16 }}>
            <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 12 }}>
              Documents ({uploadedFiles.length})
            </Typography>
            {uploadedFiles.map((file, index) => (
              <div key={index} className={classes.infoRow}>
                <span className={classes.infoLabel}>File {index + 1}</span>
                <span className={classes.infoValue}>{file.name}</span>
              </div>
            ))}
          </Card>
        )}

        {paymentData.remarks && (
          <Card className={classes.summaryCard} variant="outlined" style={{ marginTop: 16 }}>
            <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 12 }}>
              Remarks
            </Typography>
            <Typography variant="body2">{paymentData.remarks}</Typography>
          </Card>
        )}
      </div>
    );
  };

  // ─── Success Screen ──────────────────────────────────────────────────────
  if (submitted) {
    return (
      <div className={classes.root}>
        <Paper className={classes.header}>
          <Typography variant="h4" className={classes.headerTitle}>
            <Receipt fontSize="large" />
            Payment Request Submitted
          </Typography>
          <Typography variant="body1" className={classes.headerSubtitle}>
            Your payment request has been raised and is pending approval.
          </Typography>
        </Paper>
        <Paper style={{ padding: 40, textAlign: "center", borderRadius: 12 }}>
          <CheckCircle style={{ fontSize: 80, color: "#4caf50", marginBottom: 16 }} />
          <Typography variant="h5" style={{ fontWeight: 600, marginBottom: 8 }}>
            Payment Request Raised Successfully!
          </Typography>
          <Typography variant="body2" color="textSecondary" style={{ marginBottom: 24 }}>
            Amount: ₹{getJustification().netPayable.toLocaleString("en-IN")} · Type: {paymentTypes[paymentData.payment_type]?.label}
          </Typography>
          <Box display="flex" gap={2} justifyContent="center" flexWrap="wrap">
            <Button
              variant="outlined"
              onClick={() => {
                setPaymentData({
                  experienceCenterId: "",
                  payment_type: "",
                  payment_mode: "erp",
                  external_payment_method: "",
                  linked_owner: "",
                  linked_service_provider: "",
                  payee_name: "",
                  amount: "",
                  description: "",
                  payment_month: "",
                  payment_period_label: "",
                  remarks: "",
                  gst_percentage: "",
                  bank: {
                    account_number: "",
                    account_name: "",
                    bank_name: "",
                    branch_name: "",
                    ifsc_code: "",
                    account_type: "savings",
                  },
                });
                setPaymentRows([{ amount: "", gst_percentage: "" }]);
                setUploadedFiles([]);
                setSubmitted(false);
                setShowManualBankForm(false);
                setSelectedRecordBank(null);
              }}
            >
              Raise Another Payment
            </Button>
            <Button
              variant="contained"
              style={{ backgroundColor: "#1A3C6E", color: "#fff" }}
              onClick={() => history.push("/payment-approval-dashboard")}
            >
              View Approval Dashboard
            </Button>
          </Box>
        </Paper>
      </div>
    );
  }

  // ─── Main Render — single page, all sections shown at once ─────────────
  return (
    <div className={classes.root}>
      <Paper className={classes.header}>
        <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" style={{ gap: 12 }}>
          <Box>
            <Typography variant="h4" className={classes.headerTitle}>
              <Receipt fontSize="large" />
              Raise Payment Request
            </Typography>
            <Typography variant="body1" className={classes.headerSubtitle}>
              Create a new payment request for rent or services
            </Typography>
          </Box>
          <Button
            variant="outlined"
            size="small"
            onClick={() => history.push("/channel-partner-onboarding/for-miscpayment")}
          >
            Raise Channel Partner Payout
          </Button>
        </Box>
      </Paper>

      {/* ─── Notification Banner ────────────────────────────────────────── */}
      {renderNotificationBanner()}

      <Paper className={classes.stepCard}>
        {renderStep0()}
        <Divider style={{ margin: "24px 0" }} />
        {renderStep1()}
        <Divider style={{ margin: "24px 0" }} />
        {renderStep2()}
        <Divider style={{ margin: "24px 0" }} />
        {renderStep3()}

        <div className={classes.navRow} style={{ justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            className={classes.nextBtn}
            onClick={handleReviewAndSubmit}
            disabled={loading || submissionLoading || uploadingFile}
            startIcon={<Check />}
          >
            {uploadingFile ? "Uploading..." : "Submit Payment Request"}
          </Button>
        </div>
      </Paper>

      {/* ─── Confirmation dialog before final submit ────────────────────── */}
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Confirm Payment Request</DialogTitle>
        <DialogContent>
          <Typography variant="body2">
            You're about to raise a <strong>{paymentTypes[paymentData.payment_type]?.label}</strong> payment
            request for <strong>₹{Number(paymentData.amount || 0).toLocaleString("en-IN")}</strong>
            {paymentData.payment_month ? ` for ${paymentData.payment_month}` : ""}. This will be sent for approval.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)} disabled={submissionLoading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            className={classes.nextBtn}
            onClick={handleSubmit}
            disabled={submissionLoading}
            startIcon={submissionLoading ? <CircularProgress size={16} color="inherit" /> : <Check />}
          >
            {submissionLoading ? "Submitting…" : "Confirm & Submit"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(MiscPaymentRaise);